import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Subscriber } from 'rxjs';
import { getCall } from './api-calls/apicalls.service';
import { HeadersService } from './api-calls/headers.service';
import { HelpersService } from '@providers/helpers/helpers';

@Injectable()
export class ServerDocsService extends HeadersService {
    constructor(private http: HttpClient, private helper: HelpersService) {
        super(http);
    }

    get(id: string) {
        const url = getCall('storage', id, {
            access: localStorage.getItem('user-access'),
        });
        return new Observable((observer) => {
            let objectUrl: string = null;

            this.http.get(url, this.getHeaderBlob()).subscribe((m) => {
                objectUrl = URL.createObjectURL(m);
                observer.next(objectUrl);
            });

            return () => {
                if (objectUrl) {
                    URL.revokeObjectURL(objectUrl);
                    objectUrl = null;
                }
            };
        });
    }

    getImage(id: string): Observable<Blob> {
        const url = getCall('storage', id, {
            access: localStorage.getItem('user-access'),
        });
        return this._http.get(url, {
            headers: new HttpHeaders({
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            }),
            responseType: 'blob',
        });
    }

    /**
     * Given an Image UUID it returns directly the string of image in base 64
     * @param id like 3kj453-53fdg-57825-sdfgs4
     * @returns image in base 64
     */
    getImageV2(id: string): Promise<string | ArrayBuffer> {
        const url = getCall('storage', id, {
            access: localStorage.getItem('user-access'),
        });
        const response = this._http.get(url, {
            headers: new HttpHeaders({
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            }),
            responseType: 'blob',
        });
        return new Promise((resolve) => {
            response.subscribe(
                async (res) => {
                    const image = await this.helper.createImageFromBlob(res);
                    resolve(image);
                },
                (error) => {
                    console.log(error);
                }
            );
        });
    }
}
